import axios from 'axios'
import cookie from 'vue-cookie'
// TODO uncomment line below to use websockets
import connectWs from '@utils/ws'
import store from '@state/store'

const basicToken = 'Basic Mjc4MTQyNTA3NTI5OnFxWGk3Sw=='
const oauth = axios.create({
  baseURL: '/oauth/',
  headers: {
    Authorization: basicToken,
  },
})

export const state = {
  token: getCookie('aT'),
  user: {},
  userRole: [],
  isLoaded: false,
}

export const mutations = {
  SET_TOKEN(state, payload) {
    state.token = payload
  },
  SET_USER(state, payload) {
    state.user = payload
  },
  SET_USERROLE(state, payload) {
    state.userRole = payload
    state.isLoaded = true
  },
}

export const getters = {
  loggedIn(state) {
    return !!state.token
  },
}

export const actions = {
  init({ dispatch, state }) {
    setDefaultAuthHeaders(state.token)
    dispatch('validate')
      .then(() => {})
      .catch(() => {})
  },
  logIn({ commit, dispatch, getters }, { username, password } = {}) {
    return new Promise((resolve, reject) => {
      if (getters.loggedIn) {
        dispatch('validate').then(() => resolve(), e => reject(e))
      } else {
        const formData = new URLSearchParams()
        formData.append('grant_type', 'password')
        formData.append('scoped', 'read,write,trust')
        formData.append('username', username)
        formData.append('password', password)
        oauth
          .post('token', formData)
          .then(response => {
            const oauth = response.data
            setCookie(oauth)
            setDefaultAuthHeaders(oauth.access_token)
            commit('SET_TOKEN', oauth.access_token)
            dispatch('validate').then(() => resolve(), e => reject(e))
          })
          .catch(e => reject(e))
      }
    })
  },
  logOut({ commit }) {
    commit('SET_TOKEN', null)
    commit('SET_USER', null)
    commit('SET_USERROLE', null)
    clearCookie('aT')
    return true
  },
  checkToken() {
    return oauth
      .get('check_token', {
        params: {
          token: state.token,
        },
      })
      .then(response => {
        return response
      })
      .catch(error => {
        return error.response
      })
  },
  validate({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      if (!state.token) {
        return reject(Error('token is empty'))
      }
      dispatch('checkToken').then(async response => {
        if (response.status && response.status === 200) {
          const user = await axios.get('/api/1/userinfo').then(response => {
            commit('SET_USER', response.data)
            return response.data
          })
          store.dispatch('userSettings/loadUserSettings')
          await axios.get(`/api/1/user/${user.sub}/roles`).then(response => {
            commit('SET_USERROLE', response.data)
          })

          // TODO uncomment line below to start websocket
          connectWs(response.data.user_name, state.token)
          store.dispatch('userNotifications/fetch')
          resolve()
        } else {
          clearCookie('aT')
          commit('SET_TOKEN', null)
          reject(Error('auth returned non 200 OK status'))
        }
      })
    })
  },
}

// ===
// Private helpers
// ===

function getCookie(key) {
  return cookie.get(key) || null
}

function setCookie(oauth) {
  let expire = new Date()
  expire.setSeconds(expire.getSeconds() + oauth.expires_in)
  cookie.set('aT', oauth.access_token, { expires: expire })
}

function clearCookie(key) {
  cookie.delete(key)
}

// function getSavedState(key) {
//   return JSON.parse(window.localStorage.getItem(key))
// }

// function saveState(key, state) {
//   window.localStorage.setItem(key, JSON.stringify(state))
// }

function setDefaultAuthHeaders(token) {
  if (token) {
    axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
      'Access-Control-Allow-Origin': '*',
    }
  } else {
    axios.defaults.headers.common.Authorization = basicToken
  }
}
